export default function ngLoadModules(angular, UI_ROUTER_REACT_HYBRID) {/**
 * 		ANGULAR MODULES
 * 		all modules built in dependency order
 * 		Grunt will compile these inside an ES6 Module
 * 
 * 		NOTE! Below dependency order must be followed:
 * 		espui -> core -> main -> shared -> ops -> admin
 * 		
 * 		any other feature module will import from above, most use core + shared,
 * 		others may include pieces of ops or admin functionality
 */

angular.module('espui', []);

/**
 * 	CORE LIBRARIES, HTTP, AUTH, UI WIDGETS
 */
angular.module('espui.core', []);
angular.module('espui.core.session',[]);
angular.module('espui.core.api',[
	'espui.core',
	'espui.core.session'
]);

angular.module('espui.core.auth',[
	'espui.core',
	'espui.core.api',
	'espui.core.session'
]);

angular.module('espui.core.ndc',[
	'espui.core',
	'espui.core.api',
]);

angular.module('espui.core.ui', [
	'espui.core'
]);

/**
 * 	CORE HELPER SERVICES
 */
angular.module('espui.core.affoptions',[]);
angular.module('espui.core.async',[]);
angular.module('espui.core.chart',[]);
angular.module('espui.core.lookup',[]);
angular.module('espui.core.prefs',[]);

/**
 * 	MAIN CONTENT AND LAYOUT
 */
angular.module('espui.main', [
	UI_ROUTER_REACT_HYBRID,
	'espui',
	'espui.core.prefs'
]);
angular.module('espui.shared', [
	UI_ROUTER_REACT_HYBRID,
	'espui.main'
]);
angular.module('espui.home', [
	UI_ROUTER_REACT_HYBRID,
	'espui.main',
	'espui.core.chart'
]);
angular.module('espui.about', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.about-old', [UI_ROUTER_REACT_HYBRID]);

/**
 * 	WORKFORCE
 */
angular.module('espui.workforce', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core'
]);


/**
 * 	OPS
 */
 angular.module('espui.ops', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.core.async',
	'espui.core.lookup',
	'espui.main'
 ]);


/**
 * 	ADMIN
 */
angular.module('espui.admin.user', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.settings', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.ce', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.rx', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.vendor', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.groups', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.payor', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.datamgr', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.provider', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.mfrestrict', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin.claimfed', [UI_ROUTER_REACT_HYBRID]);
angular.module('espui.admin', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.core.ndc',
	'espui.core.affoptions',
	'espui.ops',
	'espui.admin.user',
	'espui.admin.settings',
	'espui.admin.ce',
	'espui.admin.rx',
	'espui.admin.vendor',
	'espui.admin.groups',
	'espui.admin.payor',
	'espui.admin.datamgr',
	'espui.admin.provider',
	'espui.admin.mfrestrict',
	'espui.admin.claimfed',
]);


/**
 * 	LOGIN
 * 	note: after ADMIN since it has a dependency on userRepo
 */
angular.module('espui.login', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.main',
	'espui.admin.user'
]);


/**
 * 	OTHER FEATURES
 */

 angular.module('espui.invoice', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.main',
	'espui.core.lookup',
	'espui.ops',
	'espui.admin.vendor'
]);

angular.module('espui.orders', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.main'
]);

angular.module('espui.report', [
	UI_ROUTER_REACT_HYBRID,
	'espui.core',
	'espui.main',
	'espui.core.lookup',
]);
}